<template src='./CustomCalendar.html'></template>
<style lang='scss' src='./CustomCalendar.scss'></style>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import axios from 'axios';

export default {
  name: "CustomCalendar",
  components: {
    FullCalendar
  },
  data: function () {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        headerToolbar: {
          left: 'prev',
          center: 'title',
          right: 'next'
        },
        locale: 'en',
        events: (info, successCallback, failureCallback) => {
          axios.get(window.eventsFeed, {
            params: {
              start: info.start,
              end: info.end,
            }
          }).then(response => {
            this.currentEvents = response.data;
            this.filteredEvents = response.data;
            successCallback(response.data);
          }).catch((error) => {
            failureCallback(error);
          });
        },
        views: {
          listDay: {buttonText: 'list day'},
          listWeek: {buttonText: 'list week'},
          listMonth: {buttonText: 'list month'},
          listYear: {buttonText: 'list year'}
        },
        height: "auto",
        nextDayThreshold: '00:00:00',
        eventContent: this.renderEventContent,
        eventDidMount: this.onEventDidMount,
        dayCellContent: this.renderDayCellContent,
        dayCellDidMount: this.onDayCellDidMount,
        dateClick: this.onDateClick,
        eventDisplay: 'block',
        dayHeaders: true
      },
      currentEvents: [],
      filteredEvents: [],
      selectedDate: null,
    }
  },
  computed: {},
  mounted() {
    console.log('The Calendar component has been mounted.');
  },
  methods: {
    renderDayCellContent(dayCellContent) {
      return {
        html: '<div class="day-number-text">' + dayCellContent.dayNumberText + '</div>'
      };
    },
    renderEventContent(event) {
      return {
        html: '<i>Event</i>'
      };
    },
    onDayCellDidMount(dayCellObject) {

    },
    onEventDidMount(elementObject) {
      let dayFrame = elementObject.el.closest('.fc-daygrid-day-frame');
      let dayNumber = dayFrame.querySelector('.day-number-text');
      dayNumber.classList.add('has-event');
    },
    onDateClick(info) {
      console.log(info);
      let dayEl = info.dayEl;
      let dayNumberTextEl = dayEl.querySelector('.day-number-text');
      if (dayNumberTextEl.classList.contains('has-event')) {
        this.filteredEvents = this.currentEvents.filter((event) => {
          let eventDateStart = moment(event.start).format("YYYY-MM-DD");
          let cellDate = moment(info.date).format("YYYY-MM-DD");
          this.selectedDate = cellDate;
          return eventDateStart === cellDate;
        });
      }
    },
    onSelectedDateDismissClick() {
      this.filteredEvents = this.currentEvents;
      this.selectedDate = null;
    }
  },
}
</script>